import { ICollection } from "components/ProjectSpecificComponents/Interfaces/FormsInterface"

export default function getProjectIdFromConfiguredCollections(
	collections: ICollection[],
	selectedPickListValue: string | number | undefined | string[]
): string {
	let projectId
	if (collections.length > 1 && selectedPickListValue != null) {
		// Multiple projects route
		projectId = collections.find(
			({ picklistValue }) => picklistValue == selectedPickListValue
		)?.projectId
	} else {
		// Single save location route
		projectId = collections[0].projectId
	}
	return projectId ?? collections[0].projectId
}
